export const getCityIdBySlug = (citiesEntities, citySlug) => {
  if (!citiesEntities || !citySlug) {
    return null;
  }

  const city = citiesEntities[citySlug.toLowerCase()];
  return city?.id || null;
};

export const getCityBySlug = (citiesEntities, citySlug) => {
  if (!citiesEntities || !citySlug) {
    return null;
  }

  return citiesEntities[citySlug.toLowerCase()] || null;
};
